/* istanbul ignore file */
/**
 * Created by gboue on 11/09/2022
 * File: DeleteOwnerModal
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { VFC, useCallback, useContext, useState } from 'react'
import {
  Body,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalProps
} from '@panwds/react-ui'
import { BUTTON_CANCEL, BUTTON_CONTINUE, LABEL_DELETE_OWNER, LABEL_DELETE_OWNER_DNS_TEXT, TITLE_DELETE_OWNER } from '../../../constants/LabelConstants'
import GlobalContext from '../../../../common/context/GlobalContext'
import { DeleteFederationOwner } from '../../../actions/IAMActions'
import StringTemplate from '../../../../common/utils/StringTemplate'
import ScreenLoader from '../../../../common/components/screenLoader/ScreenLoader'
import { IDP_OWNER_TYPES } from '../../../constants/IAMConstants'

const DeleteOwnerModal: VFC<ModalProps & {
  closeModal: () => void,
  fetchData: Function,
  domain: string,
  ownerName: string,
  type: string,
  setTxtError?: Function
}> = ({ closeModal, isOpen, fetchData, domain, ownerName, type, setTxtError }) => {
  const { treeReducer } = useContext(GlobalContext)
  const { selectedTreeNode } = treeReducer
  const tsg_id = selectedTreeNode?.id

  const [loading, setLoading] = useState(false)

  const onSubmit = useCallback(async () => {
    if (tsg_id) {
      setLoading(true)
      try {
        await DeleteFederationOwner(tsg_id, domain, ownerName)
        await fetchData({ tsg_id, loading: false, enableSuccessBanner: true })
      }
      catch (error) {
        setTxtError && setTxtError(true)
      }
      setLoading(false)
      closeModal()
    }
  }, [setLoading, fetchData, tsg_id, domain, closeModal, ownerName, setTxtError])

  return (
    <Modal size='sm' onClose={closeModal} isOpen={isOpen}>
      {loading && <ScreenLoader appearance='light'/>}
      <ModalHeader title={TITLE_DELETE_OWNER}/>
      <ModalBody addClassName='tw-flex-1'>
        <div className='tw-flex tw-flex-col tw-gap-2 tw-mb-2'>
          <Body>{StringTemplate(LABEL_DELETE_OWNER, [ownerName])}</Body>
          {type === IDP_OWNER_TYPES.DNS_TEXT && <Body>{LABEL_DELETE_OWNER_DNS_TEXT}</Body>}
        </div>
      </ModalBody>
      <ModalFooter style={{ height: '43px' }}>
        <Button
          onClick={closeModal}
          appearance="secondary"
          disabled={loading}
        >{BUTTON_CANCEL}</Button>
        <Button
          onClick={onSubmit}
          appearance='primary'
          addClassName='dark:cm-text-red-100 active:cm-bg-red-700 dark:active:cm-bg-red-400 focus-visible:cm-bg-red-600 hover:cm-bg-red-600'
          disabled={loading}
        >{BUTTON_CONTINUE}</Button>
      </ModalFooter>
    </Modal>
  )
}
export default DeleteOwnerModal
